'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RefreshButton = undefined;

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button2 = require('../Button/Button');

var _Button3 = _interopRequireDefault(_Button2);

var _RefreshButtonStyle = require('./RefreshButton.style.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RefreshButtonCore = (0, _glamorous2.default)(_Button3.default)(_RefreshButtonStyle.defaultStyle, _RefreshButtonStyle.mapPropsAndThemeToStyle);

/**
 * Refresh button for asynchronously refreshing content
 */
var RefreshButton = exports.RefreshButton = function RefreshButton(_ref) {
  var disabled = _ref.disabled,
      onClick = _ref.onClick,
      loading = _ref.loading;
  return _react2.default.createElement(
    RefreshButtonCore,
    {
      disabled: disabled || loading,
      onClick: onClick
    },
    loading ? _react2.default.createElement('i', { className: 'fa fa-pulse fa-spinner' }) : _react2.default.createElement('i', { className: 'fa fa-refresh' })
  );
};

RefreshButton.propTypes = {
  /**
   * Whether this button is disabled or not. Disabling will also disable onClick.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Action to perform on button click.
   */
  onClick: _propTypes2.default.func,
  /**
   * Whether this buttons asynchorouns action is currently executing.
   * Spins and disables the onClick when true.
   */
  loading: _propTypes2.default.bool
};

exports.default = RefreshButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/buttons/RefreshButton/RefreshButton.js
// module id = 445
// module chunks = 0